module.exports = __webpack_public_path__ + "img/2_261.e03be5e3.png";